import ChangePasswordForm from './ChangePasswordForm'
import enhance from './ChangePasswordForm.enhancer'

export default enhance(ChangePasswordForm)



// WEBPACK FOOTER //
// ./src/components/organisms/ChangePasswordForm/index.js